@use '@pes-ui/styles/src/variables';

:host {
  direction: ltr;
  width: calc(100% - 22px);
  max-width: 600px;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: calc(100vh - 41px);
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  border: 1px solid variables.$se-anthracite-grey;
  border-bottom: none;
  padding: 0 10px 10px;
  z-index: 1000;

  @media screen and (min-width: 980px) {
    left: calc(50vw - 300px) #{'/*rtl:ignore*/'};
  }
}

:host(.open) {
  top: auto;
  bottom: 0;
  background: #eee;
}

h2 {
  text-align: center;
  margin: 0;
  line-height: 40px;
  cursor: pointer;
}

label,
summary {
  min-width: 100px;
  display: inline-block;
}

section:not(.settings--outline):not(:last-child),
details:not(:last-child) {
  padding: 1px 0;
}

details {
  display: flex;
  flex-direction: column;
}

summary {
  cursor: pointer;
}

details > summary {
  &::before,
  &::after {
    content: '▼▼▼';
  }
}

details[open] > summary {
  &::before,
  &::after {
    content: '▲▲▲';
  }
}

section:not(.settings--wide),
details:not(.settings--wide) {
  @media screen and (min-width: 980px) {
    width: 50%;
  }
}

section.settings--extra {
  section:not(.settings--wide) {
    @media screen and (min-width: 980px) {
      width: 100%;
    }
  }
}

textarea {
  width: 100%;
  height: 300px;
}

textarea,
input,
select {
  font-size: 16px;
}

.input--wide {
  width: 100%;
}

.version--section {
  margin-bottom: 6px;
}

.settings--extra {
  display: grid;
  width: 100%;
  grid-template-columns: 50% 50%;
  align-items: start;
}

.settings--outline {
  box-sizing: border-box;
  padding: 10px;
  margin: 10px 0;
  outline: 1px solid variables.$se-dark-grey;

  & + & {
    margin-top: 0;
  }
}
